import type { AgentLinkPhase } from '@krp/client-runtime'

/**
 * Связь собственной кассы словами точки «Связь» (RP-UI-LINK, шаг 5) — один словарь на причину: состояние кратко и совет. Слова
 * неполадок кассы — агента дословно (ADR-8); здесь только то, о чём агент молчит (его самого не найти, не отвечает, не пускает сайт).
 */

/** Ключ действия «Проверить заново» в мини-окне: полный поиск агента и чтение кассы (исполняет окно продажи). */
export const OWN_RECHECK_ACTION = 'own.recheck'

export const OWN_RECHECK_LABEL = 'Проверить заново'

/** Агент: кратко для строки мини-окна и что делать человеку (`null` — ничего, всё отвечает или программа справится сама). */
export const OWN_AGENT_TEXTS: Readonly<Record<AgentLinkPhase, { summary: string; advice: string | null }>> = {
  connected: { summary: 'Отвечает', advice: null },
  searching: { summary: 'Ищем на этом компьютере', advice: null },
  lost: {
    summary: 'Связь потеряна',
    advice: `Проверьте, что кассовый агент запущен на этом компьютере. Программа ищет его сама; «${OWN_RECHECK_LABEL}» — проверить сейчас.`,
  },
  missing: {
    summary: 'Не найден на этом компьютере',
    advice: `Запустите кассовый агент на этом компьютере (или установите его в разделе «Оборудование») и нажмите «${OWN_RECHECK_LABEL}».`,
  },
  choose: { summary: 'Найдено несколько — выберите', advice: 'Выберите, с каким кассовым агентом работать, в разделе «Оборудование».' },
  outdated: { summary: 'Версия устарела', advice: 'Обновите кассовый агент на этом компьютере.' },
  denied: { summary: 'Не пускает этот сайт', advice: 'Добавьте адрес этого сайта в настройки кассового агента.' },
}

/** Касса без связи с агентом: о ней сейчас ничего не узнать. */
export const OWN_REGISTER_NO_AGENT = 'Не проверить: нет связи с кассовым агентом'

export const OWN_REGISTER_UNREACHABLE_ADVICE = `Проверьте, что касса включена и подключена к компьютеру, затем нажмите «${OWN_RECHECK_LABEL}».`
